module.exports = {
    Templater: require('./templater'),
    VueUtils: require('./vue-utils')
};



// WEBPACK FOOTER //
// ./resources/assets/javascript/microsistec/index.js